<template>
  <List :showbtn='false' :mapState="'cafeteriaRequests'" :allDispatch="'cafeteriaRequestsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/cafeteria/requests/list.vue